import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getStoriesPage } from "../configureStore";
import { fetchStoriesPage } from "../configureStore/storiesPage";
import { getHelmet } from "../utilities";
import { FromTopPage, Banner, GridWrapper } from "../theme";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import PageLoader from "../components/loader/PageLoader";
import StoryList from "../components/story/StoryList";
import Pagination from "../components/Pagination";
import JoinUs from "../components/JoinUs";

const Container = styled(FromTopPage)`
  header {
    margin-bottom: 60px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
`;

class Stories extends Component {
  static fetchInitialData({ page }) {
    return [fetchStoriesPage(page)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { storyList, dispatch, match } = this.props;

    if (
      !storyList.isFetching &&
      !storyList.error &&
      !storyList.stories.length
    ) {
      dispatch(fetchStoriesPage(match.params.page));
    }
  }

  render() {
    const storyList = this.props.storyList;

    if (!storyList.nbrPages && storyList.error) {
      if (storyList.error === "404") {
        return <NotFound />;
      }

      return <Error message={storyList.error} />;
    }

    if (!storyList.nbrPages) {
      return <PageLoader />;
    }

    return (
      <Container>
        <Helmet>
          {getHelmet(
            "Les articles",
            `Retrouvez tous les articles du Média.`,
            this.props.location.pathname
          )}
        </Helmet>
        <Banner>
          <GridWrapper>
            <div>
              <h1>Tous les articles</h1>
              <p>
                L'actualité mise en relief avec les reportages et les interviews
                du Média
              </p>
            </div>
          </GridWrapper>
        </Banner>
        <Pagination nbrPages={storyList.nbrPages} />
        <StoryList storyList={storyList} />
        <Pagination nbrPages={storyList.nbrPages} />
        <JoinUs />
      </Container>
    );
  }
}

Stories.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  storyList: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
    nbrPages: PropTypes.number,
    stories: PropTypes.array.isRequired,
  }).isRequired,
};

export default connect((state, ownProps) => ({
  storyList: getStoriesPage(state, ownProps.match.params.page),
}))(Stories);
